import { BaseNode } from "./baseNode";

export const ApiNode = ({ id }) => {
  return (
    <BaseNode
      id={id}
      title="API"
      leftHandles={[{ id: `${id}-request`, top: "50%", label: "Request" }]}
      rightHandles={[{ id: `${id}-response`, top: "50%", label: "Response" }]}
    >
      <div>External API Call</div>
    </BaseNode>
  );
};
